import { CHCSkiplink } from "./skiplink.component.js";
customElements.define("chc-skiplink", CHCSkiplink);
export {
  CHCSkiplink
};
//# sourceMappingURL=skiplink.js.map
